import { Link } from 'react-router-dom';

import { ReactComponent as DorLogo } from '@/assets/logos/dor-logo.svg';
import { useTokenPrices } from '@/common/providers/TokenPriceProvider/hooks.ts';

import { CurrencyTicker } from '../CurrencyTicker/component.tsx';

import styles from './component.module.scss';

const FEATURED_PRICES: (keyof ReturnType<typeof useTokenPrices>)[] = [
  'dag',
  'dor'
];

export const Header = () => {
  return (
    <header className={styles.main}>
      <div className={styles.logo}>
        <Link to="/">
          <DorLogo />
        </Link>
      </div>
      <div className={styles.tickers}>
        {FEATURED_PRICES.map((coinId) => (
          <div key={coinId} className={styles.coinWrapper}>
            <CurrencyTicker coinId={coinId} />
          </div>
        ))}
      </div>
      {/* <div className={styles.nav}>
        <a>Nodes</a>
        <a>Snapshots</a>
        <a>Transactions</a>
      </div> */}
    </header>
  );
};
